import { Controller } from "stimulus"

// #1632: de roosterkleur in het medewerkersprofiel. Een voorgestelde kleur,
// de kleurenkiezer en het HEX-veld houden elkaar bij; het voorbeeldblok laat
// meteen zien hoe een afspraak eruitziet, met witte of donkere tekst op basis
// van de luminantie (dezelfde regel als Roosterkleur in Ruby).
const HEX = /^#?([0-9a-f]{6})$/i
const LICHT = "#FFFFFF"
const DONKER = "#161311"

function normaliseer(waarde) {
  const match = HEX.exec((waarde || "").trim())
  return match ? `#${match[1].toUpperCase()}` : null
}

function kanaal(waarde) {
  const v = waarde / 255
  return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
}

function luminantie(hex) {
  const [r, g, b] = [1, 3, 5].map((i) => kanaal(parseInt(hex.slice(i, i + 2), 16)))
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

function contrast(a, b) {
  const [hoog, laag] = [luminantie(a), luminantie(b)].sort((x, y) => y - x)
  return (hoog + 0.05) / (laag + 0.05)
}

// #1263: het gedempte vlak van een blok, dezelfde formule als Roosterkleur.vlak
function vlak(hex) {
  const kanalen = [1, 3, 5].map((i) => {
    const licht = parseInt(hex.slice(i, i + 2), 16) * 0.52 + 255 * 0.48
    return Math.min(255, Math.max(0, Math.round(licht * 0.9 + 128 * 0.1)))
  })
  return `#${kanalen.map((k) => k.toString(16).padStart(2, "0")).join("").toUpperCase()}`
}

export default class extends Controller {
  static targets = ["staal", "kiezer", "hex", "blok", "fout"]

  kies(event) {
    const kleur = normaliseer(event.currentTarget.dataset.kleur)
    if (!kleur) return
    this.hexTarget.value = kleur
    this.toon(kleur)
  }

  kiezer() {
    const kleur = normaliseer(this.kiezerTarget.value)
    if (!kleur) return
    this.hexTarget.value = kleur
    this.toon(kleur)
  }

  hex() {
    const invoer = this.hexTarget.value.trim()
    const kleur = normaliseer(invoer)
    const fout = invoer !== "" && !kleur
    this.foutTarget.hidden = !fout
    this.hexTarget.setAttribute("aria-invalid", fout ? "true" : "false")
    if (kleur) {
      this.kiezerTarget.value = kleur.toLowerCase()
      this.toon(kleur)
    }
  }

  toon(kleur) {
    this.foutTarget.hidden = true
    this.hexTarget.setAttribute("aria-invalid", "false")
    this.kiezerTarget.value = kleur.toLowerCase()
    this.blokTarget.style.setProperty("--rk-kleur", kleur)
    const gedempt = vlak(kleur)
    this.blokTarget.style.setProperty("--rk-vlak", gedempt)
    this.blokTarget.style.setProperty("--rk-tekst", contrast(gedempt, DONKER) > contrast(gedempt, LICHT) ? DONKER : LICHT)
    this.staalTargets.forEach((staal) => staal.classList.toggle("is-actief", staal.dataset.kleur === kleur))
  }
}
